import React, { Fragment, Component } from 'react';
import clsx from 'clsx';
import {  Formik, Form, Field } from 'formik';
import {  TextField } from 'formik-mui';
import axios from "axios";
import withRouterCompat from '../../actions/routerWrapper'
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { LinearProgress, Fab, AppBar, Tooltip, Button, Toolbar, Typography, Dialog, DialogActions,
  DialogContent, DialogTitle, Snackbar, Modal, Backdrop, MenuItem, DialogContentText, Fade, Box } from '@mui/material';
import { connect } from 'react-redux';
import {GetApp, LockOpen, ChevronRight, MailOutlineTwoTone, KeyboardArrowUp  } from '@mui/icons-material';
import BackToTop from '../../components/shared/backToTop'
import { addUser, resetOtp } from '../../reducers/actionCreators';
import { GoogleLogin } from '@react-oauth/google';
import { baseUrl } from '../../components/shared/baseUrl';
import {motion} from 'framer-motion'

 
const StyledPaper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: '2px solid #000',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
  //width: '100%',
}));

const StyledPaper1 = styled('div')(({ theme }) => ({
    position: 'absolute',
    width: 300,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
}));

const StyledModal = styled('div')({
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  display: 'flex',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  zIndex: 1300,
});

const StyledSpace = styled('div')({
  width: '60px',
  height: 'auto',
  display: 'inline-block',
});

// Use styled for Button to avoid style prop conflicts
const StyledButton = styled(Button)(({ theme, hover }) => ({
  border: '1px solid white',
  color: hover ? 'black' : '#FFFFFF',
  backgroundColor: hover ? 'white' : 'transparent',
  '&:hover': {
    backgroundColor: 'white',
    color: 'black',
  },
}));



const types = [
  {
    value: 'teacher',
    label: 'Teacher'
  },
  {
    value: 'student',
    label: 'Student'
  }
]



const mapStateToProps = (state) => {
  console.log(state)

  return {
  user: state.user
   }
};

const mapDispatchToProps = (dispatch) => ({

  addUser: (id, token, gid, fid, eml) => dispatch(addUser(id, token, gid, fid, eml)),
  resetOtp:() => dispatch(resetOtp())

  
});

class Header extends Component {
  constructor() {
    super();
    this.state = {
      open1: false,
      open2:false,
      open3:false,
      openfb:false,
      opengm:false,
      opengm1:false,
      open:false,
      name: "",
      email: "",
      loginemail:'',
      password: "",
      loginpassword:'',
      password2: "",
      errors:'',
      status:'',
      type: 'student',
      logintype:'student',
      userdetails:'',
      fname: "",
      lname:'',
      hover:false,
      hover1:false,
      hover2:false,
      isSubmit:false
    };
    
    this.handleClickOpen1 = this.handleClickOpen1.bind(this);
    this.handleClickOpen2 = this.handleClickOpen2.bind(this);
    this.handleClickOpen3 = this.handleClickOpen3.bind(this);
    this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    this.handleGmStudent = this.handleGmStudent.bind(this);
    this.handleGmTeacher = this.handleGmTeacher.bind(this);
    this.handleFbStudent = this.handleFbStudent.bind(this);
    this.handleFbTeacher = this.handleFbTeacher.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClose1 = this.handleClose1.bind(this);
    this.handleClose2 = this.handleClose2.bind(this);
    this.handleClose3 = this.handleClose3.bind(this);
    this.handleClosefb = this.handleClosefb.bind(this);
    this.handleClosegm = this.handleClosegm.bind(this);
    this.handleClosegm1 = this.handleClosegm1.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateName = this.validateName.bind(this);
    this.validateLName = this.validateLName.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateLoginEmail = this.validateLoginEmail.bind(this);
    this.validatePass = this.validatePass.bind(this);
    this.validateLoginPass = this.validateLoginPass.bind(this);
    this.validatePass2 = this.validatePass2.bind(this);
    this.responseFailureGoogle = this.responseFailureGoogle.bind(this);
    this.responseSuccessGoogle = this.responseSuccessGoogle.bind(this);
    this.responseFailureGoogle1 = this.responseFailureGoogle1.bind(this);
    this.responseSuccessGoogle1 = this.responseSuccessGoogle1.bind(this);
    this.responseFacebook = this.responseFacebook.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter1 = this.handleMouseEnter1.bind(this);
    this.handleMouseLeave1 = this.handleMouseLeave1.bind(this);
    this.handleMouseEnter2 = this.handleMouseEnter2.bind(this);
    this.handleMouseLeave2 = this.handleMouseLeave2.bind(this);

  }


  handleFbTeacher = () => {
    
    const config = {
      //headers: { Authorization: `Bearer ${this.state.userdetails.accessToken}` }
   }
    let url = `${baseUrl}facebook/teacher`;
    axios.get(url, config)
     .then(response => {
      
       this.setState({
        errors:response.data.error
      })

      if(response.data.type ==='teacher'){

      this.props.addUser(response.data.id, response.data.token,'', response.data.facebookId, response.data.username)
      console.log(this.props.user)

      this.props.navigate('/admin/dashboard');
        
      }
     

    });

  };


  handleFbStudent = () => {
    
     const config = {
      //headers: { Authorization: `Bearer ${this.state.userdetails.accessToken}` }
   }

    let url = `${baseUrl}facebook/student`;
    axios.get(url, config)
    .then(response => {
          this.setState({
            errors:response.data.error
          })
      console.log(response.data.facebookId)
      if(response.data.type ==='student'){
      this.props.addUser(response.data.id, response.data.token,'', response.data.facebookId, response.data.username)
      console.log(this.props.user)
      this.props.navigate('/student/dashboard');;
      
    }
    });

  };

  handleGmTeacher = () => {
    const data = {
      type: 'teacher',
      user:this.state.userdetails
    }

    console.log(data);
    let url = `${baseUrl}loggmail`;
    axios.post(url, data)
    .then(response => {
      
      this.setState({
        errors:response.data.error
      })
      console.log(response.data)
      if(response.data.type ==='teacher'){

      this.props.addUser(response.data.id, response.data.token, response.data.gmailId,'', response.data.username)
      console.log(this.props.user)
      this.props.navigate('/admin/dashboard')
    }

    });

  };


  handleGmStudent = () => {
    const data = {
      type: 'student',
      user:this.state.userdetails
      
     }

    console.log(data);
    let url = `${baseUrl}loggmail`;
    axios.post(url, data)
    .then(response => {
          this.setState({
            errors:response.data.error
          })
      console.log(response.data)
      
      if(response.data.type ==='student'){
        this.props.addUser(response.data.id, response.data.token, response.data.gmailId,'', response.data.username)
        console.log(this.props.user)
        this.props.navigate('/student/dashboard');
        }

    });

  };
 
handleMouseEnter = () => {
  this.setState({
    hover:true
  })
}
handleMouseLeave = () => {
  this.setState({
    hover:false
  })
}
handleMouseEnter1 = () =>{
  this.setState({
    hover1:true
  })
}
handleMouseLeave1 = () =>{
  this.setState({
    hover1:false
  })
}
handleMouseEnter2 = () =>{
  this.setState({
    hover2:true
  })
}
handleMouseLeave2 = () =>{
  this.setState({
    hover2:false
  })
}

  handleLoginSubmit = () =>{
    this.setState({
      isSubmit:true
    })
    const data={
      username:this.state.loginemail,
      password:this.state.loginpassword,
    } 
    console.log(data)
        let url = `${baseUrl}login`;
    
        axios.post(url, data)
        .then(response => {
          
            console.log(response.data)
            this.setState({
              isSubmit:false
            })
            this.props.addUser(response.data.id, response.data.token,'','', response.data.username)
            console.log(this.props.user)

          if (response.data.type === 'teacher') {
            this.props.navigate('/admin/home');
          } else {
            console.log("Navigating to student dashboard");
            console.log("navigate function:", this.props.navigate);
            this.props.navigate('/student/dashboard');
          }

        })
        .catch(errors => 
          this.setState({
            isSubmit:false,
            errors:'Email or password incorrect/Please register first',
          })
          )
  }

  validateName = () => {
    let error;
    if (!this.state.fname) error = 'Please enter your name';
    else if (this.state.fname.length < 3) error = 'Name is too short';
    else if (this.state.fname.length >= 30) error = 'Name too long';
    return error;
  }

  validateLName = () => {
    let error;
    const { lname } = this.state;
    if (!lname) error = 'Please enter your name';
    else if (lname.length < 3) error = 'Name is too short';
    else if (lname.length >= 30) error = 'Name too long';
    return error;
  }

  validateEmail = () => {
    let error;
    const { email } = this.state;
    if (!email) error = 'Please enter email address';
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) error = 'Invalid email address';
    return error;
  }

  validateLoginEmail = () => {
    let error;
    const { loginemail } = this.state;
    console.log(this.state.loginemail)
    if (!loginemail) error = 'Please enter email address';
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(loginemail)) error = 'Invalid email address';
    return error;
  }

  validateLoginPass = () => {
    let error;
    const { loginpassword } = this.state;
    if (!loginpassword) error = 'Please enter password';
    else if (loginpassword.length < 5) error = 'Password is too short';
    else if (loginpassword.length >= 20) error = 'Password too long';
    return error;
  }

  validatePass = () => {
    let error;
    const { password } = this.state;
    if (!password) error = 'Please enter password';
    else if (password.length < 5) error = 'Password is too short';
    else if (password.length >= 20) error = 'Password too long';
    return error;
  }


  validatePass2 = () => {
    let error;
    const { password2 } = this.state;
    if (!password2) error = 'Please confirm password';
    else if (password2 !== this.state.password) error = 'Password must be matched';
    return error;
  }





  handleChange = (event) => {
    this.setState({
      type: event.target.value,
      logintype:event.target.value
    });
  }

  handleClickOpen1 = () => 
    this.setState({
      open1: !this.state.open1,
      errors:''
    });
  

  handleClickOpen2 = () => 
    this.setState({
      open2: !this.state.open2,
      errors:''
    });
  
  handleClickOpen3 = () =>
    this.setState({
      open3: !this.state.open3,
      errors:''
    });
  

  handleClose1 = () => 
    this.setState({
      open1:!this.state.open1
    });
  

  handleClose2 = () =>
    this.setState({
      open2: !this.state.open2
    });
  
  handleClose3 = () =>
    this.setState({
      open3: !this.state.open3
    });
  
  handleClosegm = () =>
    this.setState({
      opengm: !this.state.opengm
    });
  
  handleClosegm1 = () =>
    this.setState({
      opengm1: !this.state.opengm1
    });
  
  handleClosefb = () =>
    this.setState({
      openfb: !this.state.openfb
    });
  

  

  componentDidMount() {

    this.props.resetOtp();
    const { location, navigate } = this.props;
    this.currentPathname = location.pathname;
    this.currentSearch = location.search;

    if (!location || !navigate) {
      console.warn('location or navigate props are undefined in Header component');
      return;
    }

    this.currentPathname = location.pathname || '/';
    this.currentSearch = location.search || '';

  }

 

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  responseSuccessGoogle = (response) =>{
    console.log(response);
    console.log('I am in success google ')
    const data ={
      tokenId:response.credential
    }
    let url = `${baseUrl}google/token`;
    
        axios.post(url, data)
        .then(response => {
          console.log('google token posted now going next')
          this.setState({
            errors:'',
            userdetails:response.data,
          });
          {this.handleGmStudent()}
            console.log(response);
        })


  }

  responseFailureGoogle = (response) =>{
    console.log(response)
        console.log('Login failed')

  }

  responseSuccessGoogle1 = (response) =>{
    console.log(response);
    console.log('I am in success google ')

    const data ={
      tokenId:response.credential
    }
    let url = `${baseUrl}google/token`;
    
        axios.post(url, data)
        .then(response => {
          this.setState({
            errors:'',
            userdetails:response.data,
          }, () => {
            // This runs **after** state has been updated
            this.handleGmTeacher();
            console.log(this.state.userdetails); 
          });
        })


  }

  responseFailureGoogle1 = (response) =>{
    console.log(response)
    console.log('Login failed')

  }

  responseFacebook = (response) => {
    console.log(response)
    this.setState({
      errors:'',
      userdetails:response,
      openfb: !this.state.openfb
    });
  }
 

  render() {

    let { headerShadow } = this.props;
    const {errors} = this.state;

    console.log(this.props.user)

    return (
      <Fragment>

          <div className="header-nav-wrapper header-nav-wrapper-lg" />
          <AppBar
            position="fixed"
            color="primary"
            className={clsx(
              'app-header header-nav-wrapper header-nav-wrapper-lg w-100 navbar-dark d-flex align-items-center justify-content-between',
              { 'app-header--shadow': headerShadow }
            )}>
          
              <Tooltip
                arrow
                title="CT-Onlinq, a unique way to learn Computational Thinking"
                placement="bottom">
                      
                <img alt="CT-Onlinq" style={{height: 60, borderRadius: '10px',   border: "1px solid #6e8bff"}}
                        src={baseUrl+'assets/images/myLogo.jpg'} 
                />
                      
              </Tooltip>
                  
              <div>

                <Tooltip
                  arrow
                  title="Login for student"
                  placement="bottom">
                  <StyledButton
                    onClick={this.handleClickOpen2}
                    size="large"
                    color="inherit"
                    hover={this.state.hover}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    >
                    <ChevronRight />
                      Student Login                
                  </StyledButton>
                </Tooltip>

                <Tooltip
                  arrow
                  title="Login for teacher"
                  placement="bottom">
                  <StyledButton
                    onClick={this.handleClickOpen3}
                    color="inherit"
                    size="large"
                    hover={this.state.hover1}
                    onMouseEnter={this.handleMouseEnter1}
                    onMouseLeave={this.handleMouseLeave1}
                    >
                      Teacher Login                
                  </StyledButton>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;

                <Tooltip
                  arrow
                  title="Sign up here to get started"
                  placement="bottom">
                  <StyledButton
                    onClick={this.handleClickOpen1}
                    color="inherit"
                    size="large"
                    hover={this.state.hover2}
                    onMouseEnter={this.handleMouseEnter2}
                    onMouseLeave={this.handleMouseLeave2}
                    >
                    <GetApp />
                    Sign up
                  </StyledButton>
                </Tooltip>
              </div>
          
          </AppBar>
          <Box  id="back-to-top-anchor" sx={{ height: '64px' }} />

          <BackToTop>
            <Fab color="secondary" size="large" aria-label="scroll back to top">
              <KeyboardArrowUp />
            </Fab>
          </BackToTop>


          <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.open}
          onClose={this.handleClose}
          message="Registration successful/Please login"
          autoHideDuration={6000}
          />
      
          <Formik
                    initialValues={{
                    name: '',
                    email:'',
                    password:'',
                    password2:'',
                    type:'',
                    loginemail:'',
                    loginpassword:'',
                    logintype:'',
                    fname: '',
                    lname: '',
                    }}


                    onSubmit={(values, {setSubmitting}) => {
                     setTimeout(() => {                   

                      const data={
                        username:this.state.email,
                        password:this.state.password,
                        password2:this.state.password2,
                        fname:this.state.fname,
                        lname:this.state.lname,
                        type:this.state.type
                
                    } 
                    console.log(data);
                    let url = `${baseUrl}register`;
    
                    axios.post(url, data)
                    .then(response => {
                      

                      if(response.data !== null){
                        this.setState({
                          errors:'',
                          status:response.data.status,
                          open1: !this.state.open1,
                          open:true

                        });
                      }
                      setSubmitting(false);

                        console.log(response.data)
                    })
                    .catch((errors) => {
                      this.setState({
                        errors:'Registration failed'
                      }),
                      console.log(errors);
                      setSubmitting(false);
                    }); 
                     }, 500);
                    }}
                >

          {({submitForm, isSubmitting, touched, errors}) => (
          <Form>

          {/* ///////////////////////////////Modal for signup//////////////////////////////// */}

          <Dialog
            open={this.state.open1}
            onClose={this.handleClose1}
            maxWidth={'xs'}
            fullWidth={true}
            aria-labelledby="form-dialog-title"
            >
                  <div className="text-center mb-3">
                    <span><h3>Sign up here</h3></span>
                  </div>
              <DialogContent>

                <DialogContentText>
                  Enter you Details here
                </DialogContentText>
                    <p>{this.state.errors}</p>
                  <Field
                    component={TextField}
                    label="First name"
                    type="text"
                    name="fname"
                    onChange={this.onChange}
                    value={this.state.fname}
                    fullWidth={true}
                    validate={this.validateName}
                  />
                  
                  <br/>
                  <br/>
                  <Field
                    component={TextField}
                    label="last name"
                    type="text"
                    name="lname"
                    onChange={this.onChange}
                    value={this.state.lname}
                    fullWidth={true}
                    validate={this.validateLName}
                  />
                  <br/>
                  <br/>
                  <Field
                    component={TextField}
                    label="Email address"
                    type="email"
                    name="email"
                    onChange={this.onChange}
                    value={this.state.email}
                    fullWidth={true}
                    validate={this.validateEmail}
                  />
                  
                  <br/>
                  <br/>

                  <Field
                    component={TextField}
                    label="Password"
                    type="password"
                    name="password"
                    onChange={this.onChange}
                    value={this.state.password}
                    validate={this.validatePass}
                    fullWidth={true}
                  />
                  
                  <br/>
                  <br/>
                  
                  <Field
                    component={TextField}
                    label="Confirm Password"
                    type="password"
                    name="password2"
                    onChange={this.onChange}
                    value={this.state.password2}
                    validate={this.validatePass2}
                    fullWidth={true}
                  />
                 
                  <br/>
                  <br/>

                  <Field
                    component={TextField}
                    fullWidth={true}
                    name="type"
                    select
                    label="Select"
                    value={this.state.type}
                    onChange={this.handleChange}
                    helperText="Please select your user type"
                    >
                    {types.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Field>

              </DialogContent>
              
              {isSubmitting && <LinearProgress />}
              
              <DialogActions>
                <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                    onClick={submitForm}
                     >
                    Sign up
                </Button>
                
                <Button onClick={this.handleClose1} color="primary">
                  Cancel
                </Button>

              </DialogActions>
          </Dialog>


         





{/*///////////////////////////////////////////////////Modal for Login/////////////////////////////////////////////////////// */}
                              
                              <motion.div initial={{y:"-100vh", opacity: 0 }}
                                animate={{
                                  y: "200px",
                                  opacity:1,
                                  transition:{ delay: 0.5 }
                                }}>
                                <Modal
                                  open={this.state.open2}
                                  onClose={this.handleClose2}
                                  closeAfterTransition
                                  slots={{ backdrop: Backdrop }}
                                  slotProps={{
                                    backdrop: {
                                      timeout: 500,
                                    },
                                  }}
                                
                                  >
                                  
                                    <Fade in={this.state.open2}>
                                      
                                      <Box
                                        sx={{
                                          position: 'absolute',
                                          top: '50%',
                                          left: '50%',
                                          transform: 'translate(-50%, -50%)',
                                          width: 400,
                                          bgcolor: 'background.paper',
                                          border: '2px solid #000',
                                          boxShadow: 4,
                                          p: 4,
                                          borderRadius: 2,
                                          outline: 'none', // Remove default focus ring
                                        }}
                                      >
                                      
                                        <div className="text-center mb-3">
                                          <h5 id="simple-modal-description">Login with</h5>
                                        </div>
                                  
                                        <div className="text-center">
                                          <GoogleLogin
                                                onSuccess={this.responseSuccessGoogle}
                                                onError={this.responseFailureGoogle}
                                          />
                                          <p>{this.state.errors}</p>
                                        </div>

                                          <Dialog
                                              open={this.state.opengm}
                                              onClose={this.handleClosegm}
                                              aria-labelledby="gm-dialog-title"
                                          >
                                              
                                                <p>{this.state.errors}</p>
                                              <DialogTitle>Select type</DialogTitle>
                                              <DialogContent>
                                                <Typography>Are you a:</Typography>
                                                <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                  <Button
                                                    size="medium"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.handleGmStudent}
                                                  >
                                                    Student
                                                  </Button>
                                                  <StyledSpace>
                                                        or
                                                  </StyledSpace>
                                                  <Button
                                                    size="medium"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.handleGmTeacher}
                                                  >
                                                    Teacher
                                                  </Button>
                                                </Box>
                                              </DialogContent>
                                            
                                            </Dialog>
                                                                        {/* modal to check teacher/student */}

                                            
                                            
                                            <Dialog
                                              open={this.state.openfb}
                                              onClose={this.handleClosefb}
                                              aria-labelledby="fb-dialog-title"
                                            >
                                              <DialogTitle>Select type</DialogTitle>
                                              <DialogContent>
                                                <Typography>Are you a:</Typography>
                                                <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                  <Button
                                                    size="medium"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.handleGmStudent}
                                                  >
                                                    Student
                                                  </Button>
                                                  <StyledSpace>
                                                        or
                                                  </StyledSpace>
                                                  <Button
                                                    size="medium"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.handleGmTeacher}
                                                  >
                                                    Teacher
                                                  </Button>
                                                </Box>
                                              </DialogContent>
                                            </Dialog>
                                            
                                          <div className="text-center mb-3">
                                            <span> <b>OR</b></span>
                                            <h5 id="form-dialog-title2">Login with your credentials</h5>

                                            <p>{this.state.errors}</p>
                                          </div>

                                         
                                              <MailOutlineTwoTone />
                                         

                                          <Field
                                              component={TextField}
                                              name="loginemail"
                                              type="email"
                                              label="Email"
                                              onChange={this.onChange}
                                              value={this.state.loginemail}
                                              fullWidth
                                              validate={this.validateLoginEmail}

                                          />

                                          <br />
                                          <br />

                                          {/* <div> */}
                                              <LockOpen />
                                          {/* </div> */}

                                          <Field
                                              component={TextField}
                                              name="loginpassword"
                                              type="password"
                                              label="Password"
                                              onChange={this.onChange}
                                              value={this.state.loginpassword}
                                              fullWidth
                                              validate={this.validateLoginPass}
                                          />
                                          <br />
                                        
                                      {this.state.isSubmit && <LinearProgress />}

                                          <Button
                                              color="primary"
                                              variant="contained"
                                              type="submit"
                                              disabled={this.state.isSubmit}
                                              onClick={this.handleLoginSubmit}
                                              >
                                              Sign in
                                          </Button>

                                          <Button onClick={this.handleClose2} color="primary">
                                              Cancel
                                          </Button>
                                      {/* </Box> */}
                                    </Box> 
                                    </Fade>
                                </Modal>
                              </motion.div>
{/*///////////////////////////////////////////////////Modal for Teacher Login/////////////////////////////////////////////////////// */}

                              <motion.div initial={{y:"-100vh", opacity: 0 }}
                                animate={{
                                  y: "200px",
                                  opacity:1,
                                  transition:{ delay: 0.5 }
                                }}>
                                <Modal
                                  open={this.state.open3}
                                  onClose={this.handleClose3}
                                  closeAfterTransition
                                  slots={{ backdrop: Backdrop }}
                                  slotProps={{
                                    backdrop: {
                                      timeout: 500,
                                    },
                                  }}
                                
                                  >
                                  
                                    <Fade in={this.state.open3}>
                                       <Box
                                        sx={{
                                          position: 'absolute',
                                          top: '50%',
                                          left: '50%',
                                          transform: 'translate(-50%, -50%)',
                                          width: 400,
                                          bgcolor: 'background.paper',
                                          border: '2px solid #000',
                                          boxShadow: 4,
                                          p: 4,
                                          borderRadius: 2,
                                          outline: 'none', // Remove default focus ring
                                        }}
                                      >
                                      
                                        <div className="text-center mb-3">
                                          <h5 id="simple-modal-description">Login with</h5>
                                        </div>
                                  
                                        <div className="text-center">
                                          <GoogleLogin
                                                onSuccess={this.responseSuccessGoogle1}
                                                onError={this.responseFailureGoogle1}
                                          />
                                          <p>{this.state.errors}</p>
                                        </div>
                                        <Dialog
                                              open={this.state.opengm}
                                              onClose={this.handleClosegm1}
                                              aria-labelledby="gm-dialog-title"
                                          >
                                              
                                                <p>{this.state.errors}</p>
                                              <DialogTitle>Select type</DialogTitle>
                                              <DialogContent>
                                                <Typography>Are you a:</Typography>
                                                <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                  <Button
                                                    size="medium"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.handleGmStudent}
                                                  >
                                                    Student
                                                  </Button>
                                                  <StyledSpace>
                                                        or
                                                  </StyledSpace>
                                                  <Button
                                                    size="medium"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.handleGmTeacher}
                                                  >
                                                    Teacher
                                                  </Button>
                                                </Box>
                                              </DialogContent>
                                            
                                            </Dialog>
                                           <div className="text-center mb-3">
                                            <span> <b>OR</b></span>
                                            <h5 id="form-dialog-title2">Login with your credentials</h5>

                                            <p>{this.state.errors}</p>
                                          </div>

                                         
                                              <MailOutlineTwoTone />
                                         

                                          <Field
                                              component={TextField}
                                              onChange={this.onChange}
                                              value={this.state.loginemail}
                                              name="loginemail"
                                              type="email"
                                              label="Email"
                                              fullWidth
                                              validate={this.validateLoginEmail}

                                          />

                                          <br />
                                          <br />

                                          {/* <div> */}
                                              <LockOpen />
                                          {/* </div> */}

                                          <Field
                                              component={TextField}
                                              onChange={this.onChange}
                                              value={this.state.loginpassword}
                                              name="loginpassword"
                                              type="password"
                                              label="Password"
                                              fullWidth
                                              validate={this.validateLoginPass}
                                          />
                                          <br />
                                        
                                      {this.state.isSubmit && <LinearProgress />}

                                          <Button
                                              color="primary"
                                              variant="contained"
                                              type="submit"
                                              disabled={this.state.isSubmit}
                                              onClick={this.handleLoginSubmit}
                                              >
                                              Sign in
                                          </Button>

                                          <Button onClick={this.handleClose3} color="primary">
                                              Cancel
                                          </Button>

                                    </Box>

                                  </Fade>
                                </Modal>
                              </motion.div>
                           
                </Form>
              )}
            </Formik>

      </Fragment>
    );

  }
}


Header.propTypes = {
  headerShadow: PropTypes.bool,
  navigate: PropTypes.func,
  location: PropTypes.object,
  params: PropTypes.object,
  addUser: PropTypes.func.isRequired,
  resetOtpState: PropTypes.func,
  userState: PropTypes.object,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouterCompat(Header));

